import moment from "moment";
import { createContext, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { getMonth } from "utils/Times";

const Context = createContext({});

const ContextProvider = ({ children, value }) => {
	const { t } = useTranslation();
	const [ContextMenu, setContextMenu] = useState(null);

	const columns = useMemo(
		() => [
			{
				field: "report_name",
				headerName: t(
					"custom_reports.execute_reports.table.columns.report_name"
				),
				flex: 2,
				minWidth: 150,
			},
			{
				field: "creation_date",
				headerName: t(
					"custom_reports.execute_reports.table.columns.creation_date"
				),
				flex: 1,
				minWidth: 150,
			},
			{
				field: "state",
				headerName: t(
					"custom_reports.execute_reports.table.columns.state.title"
				),
				flex: 1,
				minWidth: 150,
			},
			{
				field: "format",
				headerName: t(
					"custom_reports.execute_reports.table.columns.format"
				),
				flex: 1,
				minWidth: 150,
			},
		],
		[t]
	);

	const [rows, setRows] = useState([]);
	const [checked, setChecked] = useState([]);
	const [viewActive, setViewActive] = useState("table"); // 'table', 'stepper', 'loading'
	const [range, setRange] = useState([
		moment(getMonth().start_date),
		moment(getMonth().end_date),
	]);

	const [categories, setCategories] = useState([]);
	const [reports, setReports] = useState([]);
	const [itemTreeView, setItemTreeView] = useState([]);
	const [employees, setEmployees] = useState([]);

	const [selectedReports, setSelectedReports] = useState([]);
	const [selectedEmployees, setSelectedEmployees] = useState([]);
	const [selectedDates, setSelectedDates] = useState([null, null]);

	const [loadingCategories, setLoadingCategories] = useState(false);
	const [loadingReports, setLoadingReports] = useState(false);
	const [loadingEmployees, setLoadingEmployees] = useState(false);

	const closing = () => {
		setSelectedReports([]);
		setSelectedEmployees([]);
		setSelectedDates([null, null]);
	};

	const executeReport = () => {
		const reportIds = selectedReports
			.filter((item) => !item.startsWith("category-"))
			.map((item) => item.split("-")[1]);

		const slugs = reports
			.filter((r) => reportIds.includes(`${r.report_id}`))
			.map((r) => r.slug);

		const execute = slugs.map((slug) => ({
			slug: slug,
			employees: selectedEmployees,
			start_date: selectedDates[0]?.format("YYYY-MM-DD"),
			end_date: selectedDates[1]?.format("YYYY-MM-DD"),
		}));

		console.log("Executing reports:", execute);
	};

	return (
		<Context.Provider
			value={{
				...value,
				ContextMenu,
				setContextMenu,
				columns,
				rows,
				setRows,
				checked,
				setChecked,
				viewActive,
				setViewActive,
				setCategories,
				categories,
				setReports,
				reports,
				setItemTreeView,
				itemTreeView,
				setLoadingCategories,
				loadingCategories,
				setLoadingReports,
				loadingReports,
				setEmployees,
				employees,
				setLoadingEmployees,
				loadingEmployees,
				range,
				setRange,
				selectedReports,
				setSelectedReports,
				selectedEmployees,
				setSelectedEmployees,
				selectedDates,
				setSelectedDates,
				closing,
				executeReport,
			}}
		>
			{children}
		</Context.Provider>
	);
};

export { Context, ContextProvider };
